export default __webpack_public_path__ + "static/media/logo.aedfa8ea.webp";